import PLANS_PATH from '../../constants/path'
import getCurrentReduxSelector from '../../../redux/selectors/get-current'

const getCurrentPlanSelect = getCurrentReduxSelector(
  PLANS_PATH.DATA,
  PLANS_PATH.CURRENT
)

export default getCurrentPlanSelect
